import { Component, input } from '@angular/core';

@Component({
  selector: 'onyx-divider',
  imports: [],
  templateUrl: './onyx-divider.component.html',
  styleUrl: './onyx-divider.component.scss',
  host: {
    '[class]': `variant()`,
    '[class.bottom]': `edge() === 'bottom'`,
  },
})
export class OnyxDividerComponent {
  public readonly variant = input<'default' | 'modal'>('default');
  public readonly edge = input<'top' | 'bottom'>();
}
